export enum SportsProductMenuVersion {
    V1 = 'V1',
    V2 = 'V2',
}
